import { defineMessage, defineMessages } from "react-intl";

/** `decision.*` namespace (API decision codes); unknown decisions use `deny`. */
export const decisionMessages = defineMessages({
  allow: { id: "decision.allow", defaultMessage: "Approved" },
  deny: { id: "decision.deny", defaultMessage: "Denied" },
});

/** Messages of the app shell and shared components (feature messages live in their feature). */
export const appMessages = defineMessages({
  title: { id: "app.title", defaultMessage: "S-Trust Explorer" },
  loading: { id: "app.loading", defaultMessage: "Loading" },
  errorRetry: { id: "app.error.retry", defaultMessage: "Try again" },
  notFoundTitle: { id: "app.notFound.title", defaultMessage: "Page not found" },
  languageEn: { id: "app.language.en", defaultMessage: "English" },
  languagePtBR: { id: "app.language.ptBR", defaultMessage: "Português (Brasil)" },
});

/** The router's error screen (a route failed to load or render). */
export const routeErrorMessages = defineMessages({
  title: { id: "app.routeError.title", defaultMessage: "Something went wrong" },
  body: {
    id: "app.routeError.body",
    defaultMessage: "This screen could not be shown. Reload the page to try again.",
  },
  newVersionTitle: {
    id: "app.routeError.newVersionTitle",
    defaultMessage: "A new version of the Explorer is available",
  },
  newVersionBody: {
    id: "app.routeError.newVersionBody",
    defaultMessage: "Reload the page to continue where you were.",
  },
  reload: { id: "app.routeError.reload", defaultMessage: "Reload" },
});

/** Character counter of a text area, announced to assistive technology. */
export const characterCountMessage = defineMessage<{ count: number; max: number }>(
  { id: "app.characterCount", defaultMessage: "{count, number} of {max, number} characters" },
  { typed: true },
);

/** Labels of the shared data table. */
export const tableMessages = defineMessages({
  columnChooser: { id: "table.columns", defaultMessage: "Columns" },
  previousPage: { id: "table.previous", defaultMessage: "Previous page" },
  nextPage: { id: "table.next", defaultMessage: "Next page" },
  loading: { id: "table.loading", defaultMessage: "Loading rows" },
  errorTitle: { id: "table.error", defaultMessage: "We could not load this table" },
});

export const pageStatusMessage = defineMessage<{ page: number; pages: number }>(
  { id: "table.pageStatus", defaultMessage: "Page {page} of {pages}" },
  { typed: true },
);

/** The single-use invitation link dialog (shared by console users and the Platform area). */
export const invitationLinkMessages = defineMessages({
  title: { id: "access.users.link.title", defaultMessage: "Invitation link" },
  label: { id: "access.users.link.label", defaultMessage: "Invitation link" },
  copy: { id: "access.users.link.copy", defaultMessage: "Copy link" },
  copied: { id: "access.users.link.copied", defaultMessage: "Link copied" },
  copyFailed: {
    id: "access.users.link.copyFailed",
    defaultMessage: "Copy failed; select the link and copy it manually",
  },
  close: { id: "access.users.link.close", defaultMessage: "I have copied the link" },
});

export const invitationLinkBodyMessage = defineMessage<{ email: string }>(
  {
    id: "access.users.link.body",
    defaultMessage:
      "Send this single-use link to {email} through a corporate channel. It is shown only now and cannot be retrieved again.",
  },
  { typed: true },
);

export const invitationLinkExpiresMessage = defineMessage<{ expiresAt: string }>(
  { id: "access.users.link.expires", defaultMessage: "Valid until {expiresAt}" },
  { typed: true },
);
